import React, { useEffect, useRef, useState } from "react";
import TableEmployee from "../../components/Tables/TableEmployee";
import InputSearch from "../../components/inputs/InputSearch";
import SelectWithIcon from "../../components/inputs/SelectWithIcon";
import Pagination from "../../components/Tables/Pagination";
import { useAdminListUsersQuery } from "../../services/organization/adminUsers";
import InviteEmployeeModal from "../../components/Modals/InviteEmployeeModal";
import LoadingIndicator from "../../components/LoadingIndicator";
import { useTranslation } from "react-i18next";
import { useEmployeesStickyTableHeader } from "../../hooks/useEmployeesStickyTableHeader";

const Employees = () => {
  const toolbarRef = useRef(null);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [filterKeyword, setFilterKeyword] = useState("");
  const [filters, setFilters] = useState([]);
  const [page, setPage] = useState(1);

  const { t, i18n } = useTranslation(["common", "employees"]);

  const {
    data: usersList,
    isLoading: isListUsersLoading,
    refetch,
  } = useAdminListUsersQuery({
    filters: filters.join("&"),
    page,
  });

  useEmployeesStickyTableHeader(toolbarRef, [
    usersList,
    searchKeyword,
    filterKeyword,
    i18n.language,
  ]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [page]);

  useEffect(() => {
    const result = [];
    if (searchKeyword)
      result.push(`filters[keyword]=${encodeURIComponent(searchKeyword)}`);
    if (filterKeyword) result.push(`sort=${filterKeyword}`);
    setFilters(result);
  }, [searchKeyword, filterKeyword]);

  const onInvitationSuccess = () => {
    setSearchKeyword("");
    setFilterKeyword("-created_at");
    setFilters([`sort=-created_at`]);
    setPage(1);
    refetch();
  };

  if (isListUsersLoading) return <LoadingIndicator />;

  return (
    <div className="employee ranks employees-page employees-list-page">
      <InviteEmployeeModal onInvitationSuccess={onInvitationSuccess} />

      <header ref={toolbarRef} className="employees-page__toolbar">
        <div className="employees-page__intro">
          <h1 className="title-page mb-0">{t("employees:theEmployees")}</h1>
          <ul className="employees-page__stats">
            <li>
              <span className="label label-black">
                <span className="me-2">{usersList?.users_registered_count}</span>
                {t("employees:registeredEmployee")}
              </span>
            </li>
            <li>
              <span className="label label-red">
                <span className="me-2">{usersList?.users_invited_count}</span>
                {t("employees:pendingRegisteration")}
              </span>
            </li>
          </ul>
        </div>

        <div className="employees-page__actions">
          <div className="employees-list-page__search">
            <InputSearch
              placeHolder={t("employees:searchForEmployee")}
              value={searchKeyword}
              onChange={(e) => {
                setPage(1);
                setSearchKeyword(e.target.value);
              }}
            />
          </div>
          <SelectWithIcon
            value={filterKeyword}
            onChange={(e) => {
              setPage(1);
              setFilterKeyword(e.target.value);
            }}
          >
            <option defaultValue>{t("sorting.sortBy")}</option>
            <option value="name">{t("sorting.alphabitically")}</option>
            <option value="-name">{t("sorting.alphabiticallyReversed")}</option>
            <option value="-created_at">{t("sorting.newFirst")}</option>
            <option value="created_at">{t("sorting.oldFirst")}</option>
          </SelectWithIcon>
          <button
            type="button"
            className="btn btn-main-color font-15"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop"
          >
            <span className="fas fa-user-plus fa-fw me-2"></span>
            {t("inviteNewEmployee")}
          </button>
        </div>
      </header>

      <div className="employees-page__body">
        <div className="employees-page__table-wrap">
          <TableEmployee usersList={usersList} />
        </div>

        {usersList?.data?.length != 0 ? (
          <Pagination
            current={usersList?.pagination?.current}
            pages={usersList?.pagination?.pages}
            handlePagination={(page) => setPage(page)}
          />
        ) : null}
      </div>
    </div>
  );
};

export default Employees;
